import React from "react";
import { Checkbox, FormLabel, InputAdornment } from "@material-ui/core";

import { withShowIf } from "../../../../../components/with-show-if/with-show-If.component";

import { ToggleAllProps } from "./toggle-all.props";

export const ToggleAll = withShowIf((props: ToggleAllProps) => {
  return (
    <InputAdornment position="start">
      <Checkbox onClick={props.onClick} checked={props.checked} />
      <FormLabel>All</FormLabel>
    </InputAdornment>
  );
});
